import React, { useEffect, useState, useCallback } from 'react';
import { List, Card, Avatar, Modal, Tabs, Input, Breadcrumb,Button,Layout } from 'antd';
import { ArrowLeftOutlined, LikeOutlined, CommentOutlined, CalendarOutlined, HomeOutlined } from '@ant-design/icons';
import axios from 'axios';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../../authConfig';
import { useLocation, Link } from 'react-router-dom';
import AppHeaderHomePageTemplate from '../Organism/AppHeaderHomePageTemplate';
import { format } from 'date-fns'; 
import { AlignJustify } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const { TabPane } = Tabs;

interface CommuniqueDetails {
    headerText: string;
    description: string;
    imageName: string;
    createdDate: Date;
    communiqueId: string;
    imageURL: string;
}


const ViewCommunique: React.FC = () => {
    const location = useLocation();
    const { communique_id,activeTab,activeChildTab } = location.state as { communique_id: string,activeTab: string,activeChildTab: string }; // Extract parameter from state
    const [communiqueData, setCommuniqueData] = useState<CommuniqueDetails>();
    const [imageUrl, setimageUrlData] = useState('');
    const { instance, accounts } = useMsal();
    const { t } = useTranslation();

  const fetchToken = async () => {
      const res = await instance.acquireTokenSilent({
        ...loginRequest,
        account: accounts[0]
      });
      return res.idToken;
    };
  
    useEffect(() => {
      fetchToken();
      getimageUrl(activeTab,activeChildTab);
      fetchData();
    }, [communique_id,activeTab,activeChildTab]); // Add states to the dependency array

    let imgPath="";
    const getimageUrl = async (activeTab: string, activeChildTab: string) => {
        if(activeTab === "announcement"){
            imgPath = "images/Announcement/";
        }
        else if(activeTab === "newsletter"){
            imgPath = "images/NewsLetter/";
        }
        else if(activeTab === "alerts"){
            if(activeChildTab === "it"){
                imgPath = "images/Alerts/IT/";
            }
            else if(activeChildTab === "hr"){
                imgPath = "images/Alerts/HR/";
            }
            else if(activeChildTab === "finance"){
                imgPath = "images/Alerts/Finance/";
            }
            else if(activeChildTab === "facilities"){
                imgPath = "images/Alerts/Facilities/";
            }
        }
        setimageUrlData(imgPath);
    };


    const baseURL = process.env.REACT_APP_API_URL;
  // Get the communication based on the selected tab
  const fetchData = async () => {
    try {
        const token = await fetchToken();
        if(communique_id !== ""){
            const response = await axios.get(`${baseURL}/api/COECommunique/GetCommuniqueById/${communique_id}`,
            {
                headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
                }
            });
            if (response.status === 200) {
                setCommuniqueData(response.data);  
                console.log(communiqueData?.headerText); // Log the communique data
            }
        }
      }
      catch (error) {
        console.error('Unexpected error in fetchData:', error);
      }
  };

    

  return (
    <Layout style={{ background: '#F9FAFB' }}>
      <AppHeaderHomePageTemplate />
      <div style={{ 
        maxWidth: '100%', 
        margin: '0 auto', 
        padding: '0px',
        backgroundColor: '#',
        minHeight: '100vh',
        width: '62rem'
        }}>
  
    <Breadcrumb 
    style={{ 
        backgroundColor: 'white',
        padding: '20px 20px 10px',
    }}
    >
    <Breadcrumb.Item>
        <Link to="/ApteanCommunique">
            <ArrowLeftOutlined style={{fontSize:'10px'}} />
            <span style={{ marginLeft: '5px',fontSize:'12px' }}>{t('back')}</span> {/* Add text here */}
        </Link>
    </Breadcrumb.Item>
    </Breadcrumb>
    <div style={{ 
        backgroundColor: 'white',
        padding: '0px 20px', fontWeight: '600', font:'roboto', fontSize: '18px', color: '#000000'
    }}>
        {communiqueData?.headerText}
    </div>
    <div style={{ 
        backgroundColor: 'white',
        padding: '0px 20px', font:'roboto', fontSize: '12px', color: '#000000'
    }}>
        {communiqueData?.description}
    </div>
    <div style={{ 
        backgroundColor: 'white',
        padding: '5px 20px'
    }}>
        {communiqueData && communiqueData.imageURL ? ( // Check if imageURL is not null or undefined
        <a href={`${communiqueData.imageURL}`} target="_blank" rel="noopener noreferrer">
            <img src={`${imageUrl}${communiqueData?.imageName}`} alt="Communique" style={{ justifyContent: 'center', alignItems: 'center', width: '990px' }} />
        </a>
        ) : (
            <img src={`${imageUrl}${communiqueData?.imageName}`} alt="Communique" style={{ justifyContent: 'center', alignItems: 'center', width: '990px' }} />
        )}
    </div>
</div>

    </Layout>
  );
};

export default ViewCommunique;